import { EzEnumeration2 } from '/ezlibrary/enums/EzEnumeration2.js';

import { EzObject } from '/ezlibrary/helpers/EzObject.js';
import { EzString } from '/ezlibrary/helpers/EzString.js';
import { EzArray } from '/ezlibrary/helpers/EzArray.js';

/**
 * TODO: Move this class into its own file in: src/main/webapp/integrations/enums/EzNovaIntegrationProviderId.js
 * TODO: Updated imports once moved to its own file
 *
 * @class
 * @extends {EzEnumeration2}
 * @description
 * Javascript enumeration equvalant to Java's EzNovaIntegrationProviderId.java
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import with
 *     import { EzNovaIntegrationProviderId } from '/ezlibrary/enums/EzEnumerations.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Imported by:
 *  1) /ezlibrary/enums/EzEnumerations.js
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
class EzNovaIntegrationProviderId extends EzEnumeration2 {
    /**
     * @private @field
     * Stores the singleton instance of this enumeration class.
     *
     * @type {EzRegistrationState}
     */
    static #ezEnumerationSingleton = null;

    /**
     * @static
     * Static Initialization
     */
    static {
        if (null == EzNovaIntegrationProviderId.#ezEnumerationSingleton) {
            EzNovaIntegrationProviderId.#ezEnumerationSingleton = new EzNovaIntegrationProviderId(
                // Enum property names
                [
                    'UNKNOWN',
                    'QUICKBOOKS_ONLINE',
                    'XERO',
                    'PAYCHEX',
                    'ADP_WORKFORCE_NOW',
                    'GUSTO',
                    'GUSTO_API',
                    'ACS_TECHNOLOGIES'
                ],
                // Enum property values (use default (enum property names array))
                [
                    'UNKNOWN',
                    'EZ_INTEGRATION_QUICKBOOKS_ONLINE_PROVIDER',
                    'XERO',
                    'PAYCHEX',
                    'ADP_WORKFORCE_NOW',
                    'GUSTO',
                    'GUSTO_API',
                    'ACS_TECHNOLOGIES'
                ],
                // Enum property optional data (use detail)
                null);
        }
    }
}

/**
 * TODO: Move this class into its own file in: src/main/webapp/integrations/enums/EzAuthenticationStatus.js
 * TODO: Updated imports once moved to its own file
 * @class
 * @extends {EzEnumeration2}
 * @description
 * Javascript enumeration class equvalant to Java's EzAuthenticationStatus.java
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import with
 *     import { EzAuthenticationStatus } from '/ezlibrary/enums/EzEnumerations.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *  Imported by:
 *  1) /ezlibrary/enums/EzEnumerations.js
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
export class EzAuthenticationStatus extends EzEnumeration2 {
    /**
     * @private @field
     * Stores the singleton instance of this enumeration class.
     *
     * @type {EzRegistrationState}
     */
    static #ezEnumerationSingleton = null;

    /**
     * @static
     * Static Initialization
     */
    static {
        if (null == EzAuthenticationStatus.#ezEnumerationSingleton) {
            EzAuthenticationStatus.#ezEnumerationSingleton = new EzAuthenticationStatus(
                // Enum property names
                [
                    'UNKNOWN',
                    'NOT_AUTHENTICATED',
                    'NOT_AVAILABLE',
                    'AUTHENTICATED'
                ],
                // Enum property values for each enum property name as an array
                // Enter null if the values are equal to the names
                null,
                // Optional array of additional data for eac enumeration property.
                // Enter null if not needed.
                null);
        }
    }
}

/**
 * TODO: Move this class into its own file in: src/main/webapp/integrations/enums/EzIntegrationOptions.js
 * TODO: Updated imports once moved to its own file
 * @class
 * @extends {EzEnumeration2}
 * @description
 * Javascript enumeration for the integration's options id
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import with
 *     import { EzIntegrationOptions } from '/ezlibrary/enums/EzEnumerations.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Imported by:
 *  1) /ezlibrary/enums/EzEnumerations.js
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
class EzIntegrationOptions extends EzEnumeration2 {
    /**
     * @static
     * @public @method
     * Gets the display name for the provided enumPropertyName (EzIntegrationOptions)
     *
     * @param {string}
     * A valid enumeration property name from EzIntegrationOptions
     *
     * @returns {string}
     */
    static ezToDisplayName(enumPropertyName) {
        let enumData = this[EzEnumeration2.ENUM_DATA_METHOD_NAME](enumPropertyName);

        return EzObject.isValid(enumData)
            ? EzString.stringOrDefault(
                enumData['display'],
                'UNKNOWN')
            : 'UNKNOWN';
    }

    /**
     * @private @field
     * Stores the singleton instance of this enumeration class.
     *
     * @type {EzRegistrationState}
     */
    static #ezEnumerationSingleton = null;

    /**
     * @static
     * Static Initialization
     */
    static {
        if (null == EzIntegrationOptions.#ezEnumerationSingleton) {
            EzIntegrationOptions.#ezEnumerationSingleton = new EzIntegrationOptions(
                // Enum property names
                [
                    'UNKNOWN',
                    'EZ_INTEGRATION_QUICKBOOKS_ONLINE_PROVIDER',
                    'EZ_INTEGRATION_PAYCHEX_PROVIDER',
                    'EZ_INTEGRATION_ADP_WORKFORCE_NOW_PROVIDER',
                    'EZ_INTEGRATION_GUSTO_PROVIDER',
                    'EZ_INTEGRATION_GUSTO_API_PROVIDER',
                    'EZ_INTEGRATION_ACS_TECHNOLOGIES_PROVIDER'
                ],
                // Enum property values for each enum property name as an array
                // Enter null if the values are equal to the names
                null,
                // Optional array of additional data for eac enumeration property.
                // Enter null if not needed.
                [
                    {
                        display: 'UNKNOWN'
                    },
                    {
                        display: 'QuickBooks Online'
                    },
                    {
                        display: 'Paychex Integration'
                    },
                    {
                        display: 'ADP Workflow Now Integration'
                    },
                    {
                        display: 'Gusto CSV Integration'
                    },
                    {
                        display: 'Gusto Integration'
                    },
                    {
                        display: 'ACS Technologies'
                    }
                ]);
        }
    }
}


/**
 * TODO: Move this class into its own file in: src/main/webapp/integrations/enums/EzNovaAuthType.js
 * TODO: Updated imports once moved to its own file
 * @class
 * @extends {EzEnumeration2}
 * @description
 * Javascript enumeration equivlant of Java's enumeration EzNovaAuthType.java
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import with
 *     import { EzNovaAuthType } from '/ezlibrary/enums/EzEnumerations.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Imported by:
 *  1) /ezlibrary/enums/EzEnumerations.js
 *  2) /secure/integrations/ez-integration-wizard-common.js
 *  3) /secure/integrations/ez-integration-wizard-context.js
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
class EzNovaAuthType extends EzEnumeration2 {
    /**
     * @private @field
     * Stores the singleton instance of this enumeration class.
     *
     * @type {EzRegistrationState}
     */
    static #ezEnumerationSingleton = null;

    /**
     * @static
     * Static Initialization
     */
    static {
        if (null == EzNovaAuthType.#ezEnumerationSingleton) {
            EzNovaAuthType.#ezEnumerationSingleton = new EzNovaAuthType(
                // Enum property names
                [
                    'UNKNOWN',
                    'OAUTH_1',
                    'OAUTH_2',
                    'PRIVATE_PUBLIC_KEY',
                    'GOOGLE',
                    'FACEBOOK',
                    'NONE'
                ],
                // Enum property values for each enum property name as an array
                // Enter null if the values are equal to the names
                null,
                // Enum property optional data (use detail)
                null);
        }
    }
}

/**
 * TODO: Move this class into its own file in: src/main/webapp/integrations/enums/EzOAuth2ProviderId.js
 * TODO: Updated imports once moved to its own file
 * @class
 * @extends {EzEnumeration2}
 * @description
 * Javascript enumeration equivlant of Java's enumeration EzOAuth2ProviderId.java
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import with
 *     import { EzOAuth2ProviderId } from '/ezlibrary/enums/EzEnumerations.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Imported by:
 *  1) /ezlibrary/enums/EzEnumerations.js
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
export class EzOAuth2ProviderId extends EzEnumeration2 {
    /**
     * @private @field
     * Stores the singleton instance of this enumeration class.
     *
     * @type {EzRegistrationState}
     */
    static #ezEnumerationSingleton = null;

    /**
     * @static
     * Static Initialization
     */
    static {
        if (null == EzOAuth2ProviderId.#ezEnumerationSingleton) {
            EzOAuth2ProviderId.#ezEnumerationSingleton = new EzOAuth2ProviderId(
                // Enum property names
                [
                    'UNKNOWN',
                    'NONE',
                    'INTUIT',
                    'GUSTO'
                ],
                // Enum property values for each enum property name as an array
                // Enter null if the values are equal to the names
                null,
                // Enum property optional data (use detail)
                null);
        }
    }
}


/**
 * TODO: Move this class into its own file in: src/main/webapp/integrations/enums/EzNovaOAuth2ConfigurationProviderId.js
 * TODO: Updated imports once moved to its own file
 * @class
 * @extends {EzEnumeration2}
 * @description
 * Javascript enumeration equivlant of Java's enumeration EzNovaOAuth2ConfigurationProviderId.java
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import with
 *     import { EzNovaOAuth2ConfigurationProviderId } from '/ezlibrary/enums/EzEnumerations.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Imported by:
 *  1) /ezlibrary/enums/EzEnumerations.js
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
class EzNovaOAuth2ConfigurationProviderId extends EzEnumeration2 {
    /**
     * @static
     * @public @method
     * Gets the EzOAuth2ProviderId for the provided enumPropertyName (EzNovaOAuth2ConfigurationProviderId)
     *
     * @param {string}
     * A valid enumeration property name from EzNovaOAuth2ConfigurationProviderId
     *
     * @returns {string}
     * A valid enumeration property value from EzOAuth2ProviderId
     */
    static ezToEzNovaOAuth2ProviderId(enumPropertyName) {
        let enumData = this[EzEnumeration2.ENUM_DATA_METHOD_NAME](enumPropertyName);

        return EzObject.isValid(enumData)
            ? EzOAuth2ProviderId.ezValueOf(
                EzString.stringOrDefault(
                    enumData['ezNovaOAuth2ProviderId'],
                    EzOAuth2ProviderId.UNKNOWN))
            : EzOAuth2ProviderId.UNKNOWN;
    }

    /**
     * @static
     * @public @method
     * Gets the EzNovaAuthType for the provided enumPropertyName (EzNovaOAuth2ProviderId)
     *
     * @param {string}
     * A valid enumeration property name from EzNovaOAuth2ProviderId
     *
     * @returns {string}
     * A valid enumeration property value from EzNovaAuthType
     */
    static ezToEzNovaAuthType(enumPropertyName) {
        let enumData = this[EzEnumeration2.ENUM_DATA_METHOD_NAME](enumPropertyName);

        return EzObject.isValid(enumData)
            ? EzNovaAuthType.ezValueOf(
                EzString.stringOrDefault(
                    enumData['ezNovaAuthType'],
                    EzNovaAuthType.UNKNOWN))
            : EzNovaAuthType.UNKNOWN;
    }

    /**
     * @private @field
     * Stores the singleton instance of this enumeration class.
     *
     * @type {EzRegistrationState}
     */
    static #ezEnumerationSingleton = null;

    /**
     * @static
     * Static Initialization
     */
    static {
        if (null == EzNovaOAuth2ConfigurationProviderId.#ezEnumerationSingleton) {
            EzNovaOAuth2ConfigurationProviderId.#ezEnumerationSingleton = new EzNovaOAuth2ConfigurationProviderId(
                // Enum property names
                [
                    'UNKNOWN',
                    'NONE',
                    'INTUIT',
                    'GUSTO'
                ],
                // Enum property values for each enum property name as an array
                // Enter null if the values are equal to the names
                null,
                // Enum property optional data (use detail)
                [
                    {
                        ezNovaOAuth2ProviderId: EzOAuth2ProviderId.UNKNOWN,
                        ezNovaAuthType: EzNovaAuthType.UNKNOWN
                    },
                    {
                        ezNovaOAuth2ProviderId: EzOAuth2ProviderId.NONE,
                        ezNovaAuthType: EzNovaAuthType.NONE
                    },
                    {
                        ezNovaOAuth2ProviderId: EzOAuth2ProviderId.INTUIT,
                        ezNovaAuthType: EzNovaAuthType.OAUTH_2
                    },
                    {
                        ezNovaOAuth2ProviderId: EzOAuth2ProviderId.GUSTO,
                        ezNovaAuthType: EzNovaAuthType.OAUTH_2
                    }
                ]);
        }
    }
}


/**
 * TODO: Move this class into is own file in: src/main/webapp/integrations/enums/EzNovaOAuth2ProviderId.js
 * TODO: Updated imports once moved to its own file
 * @class
 * @extends {EzEnumeration2}
 * @description
 * Javascript enumeration equivlant of Java's enumeration EzNovaOAuth2ProviderId.java
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import with
 *     import { EzNovaOAuth2ConfigurationProviderId } from '/ezlibrary/enums/EzEnumerations.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Imported by:
 *  1) /ezlibrary/enums/EzEnumerations.js
 *  2) /secure/integrations/ez-integration-wizard-common.js
 *  3) /secure/integrations/ez-integration-wizard-context.js
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
class EzNovaOAuth2ProviderId extends EzEnumeration2 {
    /**
     * @static
     * @public @method
     * Gets the EzOAuth2ProviderId for the provided enumPropertyName (EzNovaOAuth2ProviderId)
     *
     * @param {string}
     * A valid enumeration property name from EzNovaOAuth2ProviderId
     *
     * @returns {string}
     * A valid enumeration property value from EzOAuth2ProviderId
     */
    static ezToEzOAuth2ProviderId(enumPropertyName) {
        let enumData = this[EzEnumeration2.ENUM_DATA_METHOD_NAME](enumPropertyName);

        return EzObject.isValid(enumData)
            ? EzOAuth2ProviderId.ezValueOf(
                EzString.stringOrDefault(
                    enumData['ezOAuth2ProviderId'],
                    EzOAuth2ProviderId.UNKNOWN))
            : EzOAuth2ProviderId.UNKNOWN;
    }

    /**
     * @static
     * @public @method
     * Gets the EzNovaOAuth2ConfigurationProviderId for the provided enumPropertyName (EzNovaOAuth2ProviderId)
     *
     * @param {string}
     * A valid enumeration property name from EzNovaOAuth2ProviderId
     *
     * @returns {string}
     * A valid enumeration property value from EzNovaOAuth2ConfigurationProviderId
     */
    static ezToEzNovaOAuth2ConfigurationProviderId(enumPropertyName) {
        let enumData = this[EzEnumeration2.ENUM_DATA_METHOD_NAME](enumPropertyName);

        return EzObject.isValid(enumData)
            ? EzNovaOAuth2ConfigurationProviderId.ezValueOf(
                EzString.stringOrDefault(
                    enumData['ezNovaOAuth2ConfigurationProviderId'],
                    EzNovaOAuth2ConfigurationProviderId.UNKNOWN))
            : EzNovaOAuth2ConfigurationProviderId.UNKNOWN;
    }

    /**
     * @static
     * @public @method
     * Gets the EzOAuth2ProviderId for the provided EzNovaOAuth2ProviderId enumPropertyName (EzNovaOAuth2ProviderId)
     *
     * @param {string}
     * A valid enumeration property name from EzNovaOAuth2ProviderId
     *
     * @returns {string}
     * A valid enumeration property value from EzOAuth2ProviderId
     */
    static ezToEzNovaAuthType(enumPropertyName) {
        let enumData = this[EzEnumeration2.ENUM_DATA_METHOD_NAME](enumPropertyName);

        return EzObject.isValid(enumData)
            ? EzOAuth2ProviderId.ezValueOf(
                EzString.stringOrDefault(
                    enumData['ezNovaAuthType'],
                    EzOAuth2ProviderId.UNKNOWN))
            : EzOAuth2ProviderId.UNKNOWN;
    }

    /**
     * @private @field
     * Stores the singleton instance of this enumeration class.
     *
     * @type {EzRegistrationState}
     */
    static #ezEnumerationSingleton = null;

    /**
     * @static
     * Static Initialization
     */
    static {
        if (null == EzNovaOAuth2ProviderId.#ezEnumerationSingleton) {
            EzNovaOAuth2ProviderId.#ezEnumerationSingleton = new EzNovaOAuth2ProviderId(
                // Enum property names
                [
                    'UNKNOWN',
                    'NONE',
                    'INTUIT',
                    'GUSTO'
                ],
                // Enum property values for each enum property name as an array
                // Enter null if the values are equal to the names
                null,
                // Enum property optional data (use detail)
                [
                    {
                        ezOAuth2ProviderId: EzOAuth2ProviderId.UNKNOWN,
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.UNKNOWN,
                        ezNovaAuthType: EzNovaAuthType.UNKNOWN
                    },
                    {
                        ezOAuth2ProviderId: EzOAuth2ProviderId.NONE,
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.NONE,
                        ezNovaAuthType: EzNovaAuthType.NONE
                    },
                    {
                        ezOAuth2ProviderId: EzOAuth2ProviderId.INTUIT,
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.INTUIT,
                        ezNovaAuthType: EzNovaAuthType.OAUTH_2
                    },
                    {
                        ezOAuth2ProviderId: EzOAuth2ProviderId.GUSTO,
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.GUSTO,
                        ezNovaAuthType: EzNovaAuthType.OAUTH_2
                    }
                ]);
        }
    }
}

/**
 * TODO: Move this class into its own file in: src/main/webapp/integrations/enums/EzNovaAuthenticationProviderId.js
 * TODO: Updated imports once moved to its own file
 * @class
 * @extends {EzEnumeration2}
 * @description
 * Javascript enumeration equivlant of Java's enumeration EzNovaAuthenticationProviderId.java
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import with
 *     import { EzNovaAuthenticationProviderId } from '/ezlibrary/enums/EzEnumerations.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Imported by:
 *  1) /ezlibrary/enums/EzEnumerations.js
 *  2) /secure/integrations/ez-integration-wizard-state-loader.js
 *  3) /secure/integrations/ez-integration-wizard-context.js
 *  4) /secure/integrations/entities/ez-employer-integration-map.js
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
class EzNovaAuthenticationProviderId extends EzEnumeration2 {
    /**
     * @private @field
     * Stores the singleton instance of this enumeration class.
     *
     * @type {EzRegistrationState}
     */
    static #ezEnumerationSingleton = null;

    /**
     * @static
     * @public @method
     * Gets the EzNovaOAuth2ProviderId for the provided enumPropertyName (EzNovaAuthenticationProviderId)
     *
     * @param {string} enumPropertyName
     * A valid enum property name from EzNovaAuthenticationProviderId
     *
     * @returns {string}
     * A valid enum property value from EzNovaOAuth2ProviderId
     */
    static ezToEzNovaOAuth2ProviderId(enumPropertyName) {
        let enumData = this[EzEnumeration2.ENUM_DATA_METHOD_NAME](enumPropertyName);

        return EzObject.isValid(enumData)
            ? EzNovaOAuth2ProviderId.ezValueOf(
                EzString.stringOrDefault(
                    enumData['ezNovaOAuth2ProviderId'],
                    EzNovaOAuth2ProviderId.UNKNOWN))
            : EzNovaOAuth2ProviderId.UNKNOWN;
    }

    /**
     * @static
     * @public @method
     * Gets the EzNovaOAuth2ConfigurationProviderId for the provided enumPropertyName (EzNovaAuthenticationProviderId)
     *
     * @param {string} enumPropertyName
     * A valid enum property name from EzNovaAuthenticationProviderId
     *
     * @returns {string}
     * A valid enum property value from EzNovaOAuth2ConfigurationProviderId
     */
    static ezToEzNovaOAuth2ConfigurationProviderId(enumPropertyName) {
        let enumData = this[EzEnumeration2.ENUM_DATA_METHOD_NAME](enumPropertyName);

        return EzObject.isValid(enumData)
            ? EzNovaOAuth2ConfigurationProviderId.ezValueOf(
                EzString.stringOrDefault(
                    enumData['ezNovaOAuth2ConfigurationProviderId'],
                    EzNovaOAuth2ConfigurationProviderId.UNKNOWN))
            : EzNovaOAuth2ConfigurationProviderId.UNKNOWN;
    }

    /**
     * @static
     * @public @method
     * Gets the EzNovaAuthType for the provided enumPropertyName (EzNovaAuthenticationProviderId)
     *
     * @param {string} enumPropertyName
     * A valid enum property name from EzNovaAuthenticationProviderId
     *
     * @returns {string}
     * A valid enum property value from EzNovaAuthType
     */
    static ezToEzNovaAuthType(enumPropertyName) {
        let enumData = this[EzEnumeration2.ENUM_DATA_METHOD_NAME](enumPropertyName);

        return EzObject.isValid(enumData)
            ? EzNovaAuthType.ezValueOf(
                EzString.stringOrDefault(
                    enumData['ezNovaAuthType'],
                    EzNovaAuthType.UNKNOWN))
            : EzNovaAuthType.UNKNOWN;
    }

    /**
     * @static
     * Static Initialization
     */
    static {
        if (null == EzNovaAuthenticationProviderId.#ezEnumerationSingleton) {
            EzNovaAuthenticationProviderId.#ezEnumerationSingleton = new EzNovaAuthenticationProviderId(
                // Enum property names
                [
                    'UNKNOWN',
                    'NONE',
                    'INTUIT',
                    'PUZZL',
                    'XERO',
                    'PAYCHEX',
                    'ADP_WORKFORCE_NOW',
                    'GUSTO',
                    'GUSTO_API',
                    'ACS_TECHNOLOGIES'
                ],
                // Enum property values for each enum property name as an array
                // Enter null if the values are equal to the names
                null,
                // Enum property optional data (use detail)
                [
                    // Unknown
                    {
                        ezNovaOAuth2ProviderId: EzNovaOAuth2ProviderId.UNKNOWN,
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.UNKNOWN,
                        ezNovaAuthType: EzNovaAuthType.UNKNOWN
                    },
                    // NONE
                    {
                        ezNovaOAuth2ProviderId: EzNovaOAuth2ProviderId.NONE,
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.NONE,
                        ezNovaAuthType: EzNovaAuthType.NONE
                    },
                    // INTUIT
                    {
                        ezNovaOAuth2ProviderId: EzNovaOAuth2ProviderId.INTUIT,
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.INTUIT,
                        ezNovaAuthType: EzNovaAuthType.OAUTH_2
                    },
                    // PUZZL
                    {
                        ezNovaOAuth2ProviderId: EzNovaOAuth2ProviderId.NONE,
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.NONE,
                        ezNovaAuthType: EzNovaAuthType.PRIVATE_PUBLIC_KEY
                    },
                    // XERO
                    {
                        ezNovaOAuth2ProviderId: EzNovaOAuth2ProviderId.NONE,
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.NONE,
                        ezNovaAuthType: EzNovaAuthType.PRIVATE_PUBLIC_KEY
                    },
                    // PAYCHEX
                    {
                        ezNovaOAuth2ProviderId: EzNovaOAuth2ProviderId.NONE,
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.NONE,
                        ezNovaAuthType: EzNovaAuthType.NONE
                    },
                    // ADP_WORKFORCE_NOW
                    {
                        ezNovaOAuth2ProviderId: EzNovaOAuth2ProviderId.NONE,
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.NONE,
                        ezNovaAuthType: EzNovaAuthType.NONE
                    },
                    // GUSTO
                    {
                        ezNovaOAuth2ProviderId: EzNovaOAuth2ProviderId.NONE,
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.NONE,
                        ezNovaAuthType: EzNovaAuthType.NONE
                    },
                    // GUSTO_API
                    {
                        ezNovaOAuth2ProviderId: EzNovaOAuth2ProviderId.GUSTO,
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.GUSTO,
                        ezNovaAuthType: EzNovaAuthType.NONE
                    },
                    // ACS_TECHNOLOGIES
                    {
                        ezNovaOAuth2ProviderId: EzNovaOAuth2ProviderId.NONE,
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.NONE,
                        ezNovaAuthType: EzNovaAuthType.NONE
                    }
                ]);
        }
    }
}

/**
 * TODO: Remove this class once all use is migrated
 * @class
 * @extends {EzEnumeration2}
 * @description
 * Javascript enumeration that represents an id for OAuth1
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import with
 *     import { EzNovaOAuthProviderId } from '/ezlibrary/enums/EzEnumerations.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Imported by:
 *  1) /ezlibrary/enums/EzEnumerations.js
 *  2) /secure/employer/employer-dashboard-controller.js
 *  3) /secure/integration/ez-integration-controller.js
 *  4) /secure/integrations/ez-integration-wizard-common.js
 *  5) /secure/integrations/qbo/ez-qbo-integration-api-client.js
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * @deprecated
 * Migrate to using EzNovaOAuth2ProviderId
 */
class EzNovaOAuthProviderId extends EzEnumeration2 {
    /**
     * @static
     * @public @method
     * Gets the EzOAuth2ProviderId for the provided enumPropertyName (EzNovaOAuthProviderId)
     *
     * @param {string} enumPropertyName
     * A valid enum property name from EzNovaOAuthProviderId
     *
     * @returns {string}
     * A valid enum property value from EzOAuth2ProviderId
     */
    static ezToEzNovaOAuthProviderId(enumPropertyName) {
        let enumData = this[EzEnumeration2.ENUM_DATA_METHOD_NAME](enumPropertyName);

        return EzObject.isValid(enumData)
            ? EzOAuth2ProviderId.ezValueOf(
                EzString.stringOrDefault(
                    enumData['oAuth2ProviderId'],
                    EzOAuth2ProviderId.UNKNOWN))
            : null;
    }

    /**
     * @static
     * @public @method
     * Gets EzNovaOAuth2ConfigurationProviderId for the provided enumPropertyName (EzNovaOAuthProviderId)
     *
     * @param {string} enumPropertyName
     * A valid enum property name from EzNovaOAuthProviderId
     *
     * @returns {string}
     * A valid enum property value from EzNovaOAuth2ConfigurationProviderId
     */
    static ezToEzNovaOAuth2ConfigurationProviderId(enumPropertyName) {
        let enumData = this[EzEnumeration2.ENUM_DATA_METHOD_NAME](enumPropertyName);

        return EzObject.isValid(enumData)
            ? EzNovaOAuth2ConfigurationProviderId.ezValueOf(
                EzString.stringOrDefault(
                    enumData['ezNovaOAuth2ConfigurationProviderId'],
                    EzNovaOAuth2ConfigurationProviderId.UNKNOWN))
            : null;
    }

    /**
     * @static
     * @public @method
     * Gets the EzNovaAuthType for the provided enumPropertyName (EzNovaOAuthProviderId)
     *
     * @param {string} enumPropertyName
     * A valid enum property name from EzNovaOAuthProviderId
     *
     * @returns {string}
     * A valid enum property value from EzNovaAuthType
     */
    static ezToEzNovaAuthType(enumPropertyName) {
        let enumData = this[EzEnumeration2.ENUM_DATA_METHOD_NAME](enumPropertyName);

        return EzObject.isValid(enumData)
            ? EzNovaAuthType.ezValueOf(
                EzString.stringOrDefault(
                    enumData['authType'],
                    EzNovaAuthType.UNKNOWN))
            : null;
    }

    /**
     * @private @field
     * Stores the singleton instance of this enumeration class.
     *
     * @type {EzRegistrationState}
     */
    static #ezEnumerationSingleton = null;

    /**
     * @static
     * Static Initialization
     */
    static {
        if (null == EzNovaOAuthProviderId.#ezEnumerationSingleton) {
            EzNovaOAuthProviderId.#ezEnumerationSingleton = new EzNovaOAuthProviderId(
                // Enum property names
                [
                    'UNKNOWN',
                    'NONE',
                    'INTUIT',
                    'GUSTO'
                ],
                // Enum property values for each enum property name as an array
                // Enter null if the values are equal to the names
                null,
                // Enum property optional data (use detail)
                [
                    {
                        // OAuth2 provider id name (use null to use enum name)
                        oAuth2ProviderId: EzOAuth2ProviderId.NONE,
                        // Associated EzNovaOAuth2ConfigurationProviderId
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.UNKNOWN,
                        // Associated EzNovaAuthType
                        authType: EzNovaAuthType.UNKNOWN
                    },
                    {

                        // OAuth2 provider id name (use null to use enum name)
                        oAuth2ProviderId: EzOAuth2ProviderId.NONE,
                        // Associated EzNovaOAuth2ConfigurationProviderId
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.NONE,
                        // Associated EzNovaAuthType
                        authType: EzNovaAuthType.NONE
                    },
                    {
                        // OAuth2 provider id name (use null to use enum name)
                        oAuth2ProviderId: EzOAuth2ProviderId.INTUIT,
                        // Associated EzNovaOAuth2ConfigurationProviderId
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.INTUIT,
                        // Associated EzNovaAuthType
                        authType: EzNovaAuthType.OAUTH_2
                    },
                    {
                        // OAuth2 provider id name (use null to use enum name)
                        oAuth2ProviderId: EzOAuth2ProviderId.GUSTO,
                        // Associated EzNovaOAuth2ConfigurationProviderId
                        ezNovaOAuth2ConfigurationProviderId: EzNovaOAuth2ConfigurationProviderId.GUSTO,
                        // Associated EzNovaAuthType
                        authType: EzNovaAuthType.OAUTH_2
                    }
                ]);
        }
    }
}


/**
 * TODO: Move this class into its own file in: src/main/webapp/integrations/enums/EzIntegrationType.js
 * TODO: Updated imports once moved to its own file
 * @class
 * @extends {EzEnumeration2}
 * @description
 * Javascript enumeration equivlant of Java's enumeration EzIntegrationType.java
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import with
 *     import { EzIntegrationType } from '/ezlibrary/enums/EzEnumerations.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Imported by:
 *  1) /ezlibrary/enums/EzEnumerations.js
 *  2) /ezlibrary/EzClockerContext/ez-context.js
 *  3) /secure/widgets/EzExportReportDialog/ez-export-report-dialog.js
 *  4) /secure/integrations/ez-integrations-service-client.js
 *  5) /secure/integrations/EzIntegrationType.js
 *  6) /secure/integrations/ez-integration-wizard-common.js
 *  7) /secure/integrations/ez-integration-wizard-context.js
 *  8) /secure/integrations/ez-integration-wizard-state-loader.js
 *  9) /secure/integrations/qbo/ez-qbo-integration-wizard-launcher.js
 *  10) /secure/integrations/entities/ez-employer-integration-map.js
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
class EzIntegrationType extends EzEnumeration2 {
    /**
     * @static
     * @public @method
     * Gets an array EzNovaIntegrationProviderId that support the EzIntegrationType for the provided enumPropertyName
     *
     * @param {string} enumPropertyName
     * A valid enum property name for EzIntegrationType
     *
     * @returns {array}
     */
    static ezGetSupportedIntegrationProvidersForEzIntegrationType(enumPropertyName) {
        let enumData = this[EzEnumeration2.ENUM_DATA_METHOD_NAME](enumPropertyName);

        return EzObject.isValid(enumData)
            ? EzArray.arrayOrEmpty(enumData['supportedIntegrationProviders'])
            : [];
    }

    /**
 * @private @field
 * Stores the singleton instance of this enumeration class.
 *
 * @type {EzRegistrationState}
 */
    static #ezEnumerationSingleton = null;

    /**
     * @static
     * Static Initialization
     */
    static {
        if (null == EzIntegrationType.#ezEnumerationSingleton) {
            EzIntegrationType.#ezEnumerationSingleton = new EzIntegrationType(
                // Enum property names
                [
                    'UNKNOWN',
                    'TIME_ENTRY_EXPORT',
                    'TIME_ENTRY_EXPORT_FILE'
                ],
                // Enum property values for each enum property name as an array
                // Enter null if the values are equal to the names
                null,
                // Enum property optional data (use detail)
                [
                    {
                        supportedIntegrationProviders: [
                            EzNovaIntegrationProviderId.UNKNOWN
                        ]
                    },
                    {
                        supportedIntegrationProviders: [
                            EzNovaIntegrationProviderId.EZ_INTEGRATION_QUICKBOOKS_ONLINE_PROVIDER
                        ]
                    },
                    {
                        supportedIntegrationProviders: [
                            EzNovaIntegrationProviderId.XERO,
                            EzNovaIntegrationProviderId.PAYCHEX,
                            EzNovaIntegrationProviderId.ADP_WORKFORCE_NOW,
                            EzNovaIntegrationProviderId.GUSTO_API,
                            EzNovaIntegrationProviderId.GUSTO,
                            EzNovaIntegrationProviderId.ACS_TECHNOLOGIES
                        ]
                    }
                ]);
        }
    }
}

export {
    EzIntegrationOptions,
    EzNovaAuthType,
    EzNovaOAuth2ProviderId,
    EzNovaOAuth2ConfigurationProviderId,
    EzNovaAuthenticationProviderId,
    EzNovaOAuthProviderId,
    EzIntegrationType,
    EzNovaIntegrationProviderId
};
